import subscriptions from './subscriptions'

const workspaces = {
    subscriptions: Object.assign(subscriptions, subscriptions),
}

export default workspaces